//
// BaseUIModel.js
// commons
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "../moduleBuilder";
import EventDispatcher from "../events/EventDispatcher";
import "../lib";
import "./BaseModel";

var BaseUIModel = createModule("commons::BaseUIModel", ["commons::PropertyOwner","commons::BaseModel"], EventDispatcher, [
    ,
    ,
    ,
    ,
    ,
    ,
    ,
]);
export default BaseUIModel;
